import { CALL_TIME_ITEMS } from "@/helper/callTimeHelper";

export default {
  data() {
    return {
      callTimeError: null,
      callTimeItems: CALL_TIME_ITEMS,
    };
  },
  computed: {
    selectedCallTime: {
      get() {
        return this.agent?.customer?.call_time ?? null;
      },
      set(val) {
        if (this.agent?.customer) {
          this.$set(this.agent.customer, "call_time", val);
        }
        if (this.$store.state.request_info?.customer) {
          this.$set(this.$store.state.request_info.customer, "call_time", val);
        }
      },
    },
  },
};
